{#if reloading}
  <ul>
    <li id="reloading">Atualizando...</li>
  </ul>
{:else if data.balance.error}
  <ul>
    <li id="error">{data.balance.error}</li>
  </ul>
{:else}
  <ul>
    <li id="total">
      <strong>Total</strong>:
      <span>R${formatNumber(data.balance.balance)}</span>
    </li>
    <li id="total">
      <strong>A liberar</strong>:
      <span>R${formatNumber(data.balance.withheldBalance)}</span>
    </li>
    <li id="total">
      <strong>Disponível</strong>:
      <span>R${formatNumber(data.balance.transferableBalance)}</span>
    </li>
  </ul>
  <hr>
  <form method=post on:submit|preventDefault={transfer} id="transfer-form">
    <p>Solicitar transferência:</p>
    <label>
      <span>Valor:</span>
      <input type="number" bind:value={amount} min="0" step="0.01" max="{data.balance.transferableBalance}">
    </label>
    <button type="submit" class="button" class:loading={requesting} disabled={!canSubmit}>{buttonLabel}</button>
    <button type="button" class="button" on:click={setMaxAmount} disabled={requesting}>Valor Máximo</button>
  </form>
{/if}

<script>
  export let data = {};

  import {formatNumber} from '../utils/format-number';

  const ajax = window.jQuery.ajax;

  let amount = 0;
  let canSubmit = false;
  let requesting = false;
  let reloading = false;

  $: canSubmit = !requesting && amount > 0;

  $: buttonLabel = requesting ? 'Solicitando' : 'Fazer solicitação';

  function setMaxAmount () {
    amount = data.balance.transferableBalance;
  }

  function transfer (e) {
    if (!canSubmit) return;

    requesting = true;

    const req = ajax(window.ajaxurl, {
      method: 'POST',
      data: {
        action: data.ajax.action,
        [data.ajax.nonce_arg]: data.ajax.nonce,
        transfer_amount: amount
      }
    })

    req.always(function () {
      requesting = false
    });

    req.then(function (res) {
      if (res.success) {
        alert( 'Solicitação enviada com sucesso.' );
        window.location.reload();
        reloading = true;
      } else {
        alert(req.data.error_message);
      }
    });

    req.fail(function () {
      if (req.responseJSON) {
        alert(req.responseJSON.data.error_message);
      }
    });
  }
</script>

